.glyph { display: inline-flex; align-items: center; justify-content: center; flex: none; width: 16px; height: 16px; font-family: var(--font-cond); font-size: 12px; font-weight: 900; line-height: 1; }
.glyph[data-source='fit'] { border: 1.2px solid var(--ink); color: var(--ink); }
.glyph[data-source='strava'] { background: var(--strava); color: var(--paper); }
@media (min-width: 640px) {
  .glyph { display: none; }
}
